import { CheckCircle, Loader2 } from 'lucide-react'
import { useEffect } from 'react'

interface KycRedirectSuccessProps {
  onComplete: () => void
}

const KycRedirectSuccess = ({ onComplete }: KycRedirectSuccessProps) => {
  useEffect(() => {
    // Redirect to Complete24 after showing success message
    const timer = setTimeout(() => {
      onComplete()
    }, 3000)

    return () => clearTimeout(timer)
  }, [onComplete])

  return (
    <div className="w-full h-screen bg-white dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center space-y-6 max-w-md mx-auto p-6">
        <div className="w-20 h-20 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center mx-auto">
          <CheckCircle className="w-10 h-10 text-green-600 dark:text-green-400" />
        </div>
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Verification Successful!
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Your identity verification has been completed successfully.
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-500">
            Redirecting you to the next step...
          </p>
        </div>
        <div className="flex justify-center">
          <Loader2 className="w-6 h-6 animate-spin text-green-600" />
        </div>
      </div>
    </div>
  )
}

export default KycRedirectSuccess
